import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useNavigation } from 'expo-router'

type FetchCallback = () => Promise<void>
type Options<T> = Pick<UseQueryOptions<T>, 'enabled' | 'refetchInterval'>

const defaultIntervalMs = 5_000
export const usePollingQuery = (name: string, fetchCallback: FetchCallback, options?: Options<boolean>) => {
  const navigation = useNavigation()
  const isFocused = navigation.isFocused()
  return useQuery({
    gcTime: Infinity,
    queryKey: ['polling', name],
    queryFn: async () => {
      await fetchCallback()
      return true
    },
    refetchInterval: options?.refetchInterval ?? defaultIntervalMs,
    enabled: isFocused ?? options?.enabled,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true
  })
}
